import { NavLink, Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "@shared/api";
import { Banner } from "@shared/ui";

interface Health {
  ok: boolean;
  accessConfigured: boolean;
  masterKeySet: boolean;
  devBypass: boolean;
}

export function AdminLayout() {
  const [health, setHealth] = useState<Health | null>(null);

  useEffect(() => {
    api.get<Health>("/api/health").then(setHealth).catch(() => setHealth(null));
  }, []);

  return (
    <div className="shell">
      <nav className="sidebar">
        <div className="brand">
          <span aria-hidden="true">🕰️</span> Cuckoo
        </div>
        <NavLink to="/plans" className="nav-link">
          Plans
        </NavLink>
        <NavLink to="/queue" className="nav-link">
          Queue
        </NavLink>
        <NavLink to="/workspaces" className="nav-link">
          Clients
        </NavLink>
        <NavLink to="/ai" className="nav-link">
          AI keys
        </NavLink>
      </nav>
      <main className="main">
        {health && !health.masterKeySet ? (
          <Banner kind="error">
            MASTER_KEY is not set, so API keys cannot be stored. Generate one with{" "}
            <code className="mono">openssl rand -base64 32</code> and save it with{" "}
            <code className="mono">wrangler secret put MASTER_KEY</code>.
          </Banner>
        ) : null}
        {health && !health.accessConfigured ? (
          <Banner kind="warn">
            {health.devBypass
              ? "Running with the local development bypass. Anyone who can reach this Worker can use the admin area. Set ACCESS_TEAM_DOMAIN and ACCESS_AUD before relying on it."
              : "Cloudflare Access is not configured, so the admin area is locked. Set ACCESS_TEAM_DOMAIN and ACCESS_AUD to open it."}
          </Banner>
        ) : null}
        <Outlet />
      </main>
    </div>
  );
}
